import React from "react";
import config from "../data/config";
import ShareIconWrapper from "./ShareIconWrapper";

/* image imports */

const SwiperBlock = ({ chapterInfo, pauseSlideOnTap, callGaHandler }) => {

  const pauseSlide = () => {
    pauseSlideOnTap(true);
  }

  return (
    <div className="swiper-block">
      <ShareIconWrapper callGaHandler={callGaHandler} pauseSlideOnTap={pauseSlideOnTap} />

      <picture onClick={pauseSlide}>
        <source media="(orientation: portrait)" />
        <img
          src={`${config.BUCKET_URL}${chapterInfo?.chapter_media_url}`}
          alt=""
        />
      </picture>
      <div className="slide-footer d-none d-xl-block">
        <div className="footer-left">
          <div className="slide-main-title">{chapterInfo?.chapter_name}</div>
          <div className="slide-hashtags">
            {chapterInfo?.chapter_hash_tags &&
            chapterInfo?.chapter_hash_tags.length > 0 ? (
              chapterInfo?.chapter_hash_tags.map((item, index) => (
                <span key={index}>{item}</span>
              ))
            ) : (
              <span></span>
            )}
          </div>
        </div>
        {/* <div className="slide-footer-image">
                    <img src={`${mediaData["footSwipeDummy"]}`} alt="" />
                  </div> */}
      </div>
    </div>
  );
};

export default SwiperBlock;
